import { config } from 'affiny-core/env';
import { EEnvPlatform } from 'affiny-core/env.types';
import { selectAccountAttributeElement } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { ReflistResource } from '../../core/resources/reflist.resource';
import { getObjectMappingQuestions, reflistsMapper } from './reflists.mapper';

export function* getReflists() {
  const kvk: ReturnType<typeof selectAccountAttributeElement> = yield select(
    selectAccountAttributeElement,
    'kvk'
  );
  const response = yield call(ReflistResource.getReflist, kvk);

  return {
    ...reflistsMapper(
      response.data,
      getObjectMappingQuestions(config.env.platform !== EEnvPlatform.wad)
    ),
    platform: config.env.platform,
    kvk: kvk,
  };
}
